import apiClient from './apiClient';

export const createinvoice = async (title, pages) => {
  try {
    const response = await apiClient.post('/contracts', { title, pages });
    return response.data;
  } catch (error) {
    console.error('Error creating contract:', error);
    throw error;
  }
};

export const deletequestionnaires = async (emailId) => {
  try {
    await apiClient.delete(`/questionnaires/${emailId}`);
  } catch (error) {
    throw new Error(`Failed to delete questionnaire with ID ${emailId}: ${error.message}`);
  }
};
